import { render } from "./AddBranch.vue?vue&type=template&id=245b4e5b&scoped=true"
import script from "./AddBranch.vue?vue&type=script&lang=js"
export * from "./AddBranch.vue?vue&type=script&lang=js"

import "./AddBranch.vue?vue&type=style&index=0&id=245b4e5b&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-245b4e5b"]])

export default __exports__